export const defaultLocale = 'es'

export const messages = {
  es: {
    navbar: {
      etusivu: 'Inicio',
      kirjaudu: 'Registrarse',
      kirjauduulos: 'Cerrar sesión',
      kirjautuneena: 'Your account',
      korkeakoulu: 'Universidad del Aula del Derecho de Autor',
      info: 'Información',
      opettajalle: 'Para el profesor',
      imateriaalioikeudet: 'Derechos de propiedad intelectual',
      tekijanoikeudet: 'Derechos de autor',
      luovuttaminen: 'Cesión de los derechos de autor',
      kaytto: 'Uso de las obras',
      oma: 'Producción propia',
      cookie: 'Utilizamos cookies en nuestro sitio web para ofrecerte la mejor experiencia de usuario posible.\n Al continuar navegando por el sitio, aceptas el uso de cookies.',
      lisatietoja: 'Información adicional sobre las cookies',
      hyvaksyn: 'Aceptar'
    },
    general: {
      ladataan: 'Cargando...',
      jatka: '¿Continuar más tarde donde lo dejaste?',
      siirry: 'Ir a',
      aloita: 'Empezar',
      seuraava: 'Siguiente',
      edellinen: 'Anterior',
      kylla: 'Sí',
      ei: 'No',
      jatkat: 'Continuar',
      oikein: '¡Correcto',
      vaarin: 'Incorrecto',
      hienoa: '¡Muy bien!'
    },
    footer: {
      tekijat: 'Autores',
      kayttoehdot: 'Aviso legal',
      evasteet: 'Uso de cookies',
      saavutettavuus: 'Accesibilidade do sitio web campusderechodeautor.org',
      yksityisyys: 'Política de privacidade',
      yhteystiedot: 'Datos de contacto',
      unohditko: '¿Olvidaste tu código de registro?',
      jaa: '¡Compartir en las redes sociales!',
      copyright: '© Kopiosto ry. CEDRO tiene licencia para la versión en español.',
      contact: 'Datos de contacto',
      info: 'Info',
      some: 'Sigue a CEDRO en las redes sociales'
    },
    login: {
      ohje: 'Al iniciar sesión, puedes guardar los exámenes que hayas aprobado y continuar más tarde, incluso en un dispositivo distinto. Tu dirección de correo electrónico no se guardará, y no se usará para ningún otro fin distinto que para enviarte el código de inicio de sesión.',
      email: 'Tu dirección de correo electrónico',
      koodi: 'Code',
      kirjaudu: 'Inicio de sesión',
      kirjaudutaan: 'Iniciando sesión...',
      kirjauduulos: 'Cerrar sesión',
      kirjautuneena: 'Actualmente conectado',
      jatka: 'Continuar',
      jatkakirjautumatta: 'Continuar sin iniciar sesión',
      eikoodia: 'Si no tienes código o lo has olvidado, deja el campo en blanco y te enviaremos el código a tu correo electrónico.',
      laheta: 'Enviar un código',
      lahetetaan: 'Enviando...',
      lahetetty: 'Código enviado',
      jatkamyohemmin: 'Continuar más tarde donde lo dejaste',
    }
  },
  gl: {
    navbar: {
      etusivu: 'Inicio',
      kirjaudu: 'Rexistrarse',
      kirjauduulos: 'Pechar sesión',
      kirjautuneena: 'A túa conta',
      korkeakoulu: 'Campus do Dereito de Autorr',
      info: 'Información',
      opettajalle: 'Para o profesor',
      imateriaalioikeudet: 'Dereitos de propiedade intelectual',
      tekijanoikeudet: 'Dereitos de autor',
      luovuttaminen: 'Cesión dos dereitos de autor',
      kaytto: 'Uso das obras',
      oma: 'Produción propia',
      cookie: 'Utilizamos cookies no noso sitio web para ofrecerche a mellor experiencia de usuario posible. Ao continuar navegando polo sitio, aceptas o uso de cookies.',
      lisatietoja: 'Información adicional sobre as cookies',
      hyvaksyn: 'Aceptar'
    },
    general: {
      ladataan: 'Cargando...',
      jatka: 'Continuar máis tarde onde o deixaches?',
      siirry: 'Ir a',
      aloita: 'Comezar',
      seuraava: 'Seguinte',
      edellinen: 'Anterior',
      kylla: 'Si',
      ei: 'Non',
      jatkat: 'Continuar',
      oikein: 'Correcto',
      vaarin: 'Incorrecto',
      hienoa: 'Xenial! Aprobaches o exame.'
    },
    footer: {
      tekijat: 'Autores',
      kayttoehdot: 'Aviso legal',
      evasteet: 'Uso de cookies',
      saavutettavuus: 'Accesibilidade do sitio web campusderechodeautor.org',
      yksityisyys: 'Política de privacidade',
      yhteystiedot: 'Datos de contacto',
      unohditko: 'Esqueciches o teu código de rexistro?',
      jaa: 'Compartir nas redes sociais!',
      copyright: '© Kopiosto ry. CEDRO ten licenza para a versioìn en galego.',
      contact: 'Datos de contacto',
      info: 'Información',
      some: 'Sigue a Aula do Dereito de Autor nas redes sociais'
    },
    login: {
      ohje: 'Ao iniciar sesión, podes gardar os exames que completaras e continuar máis tarde, incluso noutro dispositivo. O teu enderezo de correo electrónico non se almacenará en ningún lugar e non utilizaremos o enderezo de correo electrónico para ningún outro fin que non sexa enviar un código de inicio de sesión.',
      email: 'Tu dirección de correo electrónico',
      koodi: 'Code',
      kirjaudu: 'Iniciando sesión',
      kirjaudutaan: 'Iniciando sesión...',
      kirjauduulos: 'Pechar sesión',
      kirjautuneena: 'Estás conectado',
      jatka: 'Continuar',
      jatkakirjautumatta: 'Continuar conectado',
      eikoodia: 'Se non tes código ou o esqueciches, deixa o campo en branco e enviarémosche o código ao teu correo electrónico.',
      laheta: 'Enviar código',
      lahetetaan: 'Enviado...',
      lahetetty: 'Enviouse o código',
      jatkamyohemmin: 'Continuar máis tarde onde o deixaches',
    }
  },
  ca: {
    navbar: {
      etusivu: 'Inici',
      kirjaudu: 'Registrar-se',
      kirjauduulos: 'Tancar sessió',
      kirjautuneena: 'Estàs connectat',
      korkeakoulu: 'Campus del dret d’autor',
      info: 'Informació',
      opettajalle: 'Per al professor',
      imateriaalioikeudet: 'Drets de propietat intellectual',
      tekijanoikeudet: 'Drets d’autor',
      luovuttaminen: 'Cessió dels drets d’autor',
      kaytto: 'Ús de les obres',
      oma: 'Producció pròpia',
      cookie: 'Utilitzem cookies en el nostre lloc web per oferir-te la millor experiència d’usuari possible. En continuar navegant pel lloc, acceptes l’ús de cookies.',
      lisatietoja: 'Informació addicional sobre les cookies',
      hyvaksyn: 'Acceptar'
    },
    general: {
      ladataan: 'Carregant...',
      jatka: 'Continuar més tard?',
      siirry: 'Anar a',
      aloita: 'Començar',
      seuraava: 'Següent',
      edellinen: 'Anterior',
      kylla: 'Sí',
      ei: 'No',
      jatkat: 'Continuar',
      oikein: 'Correcte',
      vaarin: 'Incorrecte',
      hienoa: 'Molt bé!'
    },
    footer: {
      tekijat: 'Autors',
      kayttoehdot: 'Avís legal',
      evasteet: 'Ús de cookies',
      saavutettavuus: 'Accessibilitat del lloc web campusderechodeautor.org',
      yksityisyys: 'Política de privacitat',
      yhteystiedot: 'Dades de contacte',
      unohditko: 'Has oblidat el teu codi de registre?',
      jaa: 'Comparteix-ho a les xarxes socials!',
      copyright: '© Kopiosto ry. CEDRO té llicència per a la versió en català.',
      contact: 'Dades de contacte',
      info: 'Informació',
      some: 'Segueix l’Aula del Dret d’Autor a les xarxes socials'
    },
    login: {
      ohje: 'En iniciar sessió, pots desar els exàmens que hagis completat i continuar més tard, fins i tot en un altre dispositiu. La teva adreça electrònica no s’emmagatzemarà enlloc i no la utilitzarem per a cap altra finalitat que no sigui enviar un codi d’inici de sessió.',
      email: 'Tu dirección de correo electrónico',
      koodi: 'Codi d’inici de sessió',
      kirjaudu: 'Iniciant sessió',
      kirjaudutaan: 'Iniciant sessió...',
      kirjauduulos: 'Tancar sessió',
      kirjautuneena: 'Estàs connectat',
      jatka: 'Continuar',
      jatkakirjautumatta: 'Continuar sin iniciar sesión',
      eikoodia: 'Si no tens codi o l’has oblidat, deixa el camp en blanc i enviarem el codi a la teva adreça electrònica.',
      laheta: 'Enviar el codi',
      lahetetaan: 'Enviat...',
      lahetetty: 'El codi s’ha enviat',
      jatkamyohemmin: 'Continuar',
    }
  },
  eu: {
    navbar: {
      etusivu: 'Hasi',
      kirjaudu: 'Erregistratu',
      kirjauduulos: 'Itxi saioa',
      kirjautuneena: 'Zure kontua',
      korkeakoulu: 'Egile Eskubideen Campusa',
      info: 'Informazioa',
      opettajalle: 'Irakaslearentzat',
      imateriaalioikeudet: 'Jabetza intelektualeko eskubideak',
      tekijanoikeudet: 'Egile-eskubideak',
      luovuttaminen: 'Egile-eskubideen lagapena',
      kaytto: 'Obren erabilera',
      oma: 'Ekoizpen propioa',
      cookie: 'Gure webgunean, cookieak erabiltzen ditugu ahalik eta erabiltzaile-esperientziarik onena eskaintzeko. Webgunean nabigatzen jarraituz gero, onartu egiten duzu cookieon erabilera.',
      lisatietoja: 'Cookieei buruzko informazio osagarria',
      hyvaksyn: 'Onartu'
    },
    general: {
      ladataan: 'Kargatzen...',
      jatka: 'Jarraitu geroago, orain uzten duzun tokian?',
      siirry: 'Joan hona',
      aloita: 'Hasi',
      seuraava: 'Hurrengoa',
      edellinen: 'Aurrekoa',
      kylla: 'Bai',
      ei: 'Ez',
      jatkat: 'Jarraitu',
      oikein: 'Zuzena',
      vaarin: 'Okerra',
      hienoa: 'Ederki! Gainditu duzu azterketa!'
    },
    footer: {
      tekijat: 'Egileak',
      kayttoehdot: 'Lege-oharra',
      evasteet: 'Cookieen erabilera',
      yhteystiedot: 'Harremanetarako datuak',
      saavutettavuus: 'Campusderechodeautor.org webgunearen erabilerraztasuna',
      yksityisyys: 'Pribatutasun-politika',
      unohditko: 'Erregistro-kodea ahaztu duzu?',
      jaa: 'Partekatu sare sozialetan!',
      copyright: '© Kopiosto ry. CEDROk badu lizentzia euskarazko bertsiorako.',
      contact: 'Harremanetarako datuak',
      info: 'Informazioa',
      some: 'Jarraitu Egile Eskubideen Ikasgelari sare sozialetan'
    },
    login: {
      ohje: 'Saioa hastean, gorde ditzakezu egin dituzun azterketak, eta geroago jarraitu, baita beste gailu batean ere. Ez da inon gordeko zure helbide elektronikoa, eta ez dugu ezertarako erabiliko, saioa hasteko kodea bidaltzeko beste ezertarako ez.',
      email: 'Tu dirección de correo electrónico',
      koodi: 'Saioa hasteko kodea',
      kirjaudu: 'Erregistratu',
      kirjaudutaan: 'Saioa hasten...',
      kirjauduulos: 'Itxi saioa',
      kirjautuneena: 'Konektatuta zaude',
      jatka: 'Jarraitu',
      jatkakirjautumatta: 'Jarraitu konektatuta',
      eikoodia: 'Ez badaukazu koderik edo ahaztu egin baduzu, utzi eremua hutsik eta zure helbide elektronikora bidaliko dizugu.',
      laheta: 'Bidali kodea',
      lahetetaan: 'Bidalita...',
      lahetetty: 'Kodea bidali da',
      jatkamyohemmin: 'Jarraitu geroago, orain uzten duzun tokian?',
    }
  },
  en: {
    navbar: {
      etusivu: 'Homepage',
      kirjaudu: 'Login',
      kirjauduulos: 'Log out',
      kirjautuneena: 'Your account',
      korkeakoulu: 'Kopiraittila academy',
      info: 'Info',
      opettajalle: 'Teachers',
      imateriaalioikeudet: 'Intellectual property rights',
      tekijanoikeudet: 'Copyright',
      luovuttaminen: 'Transferring copyrights',
      kaytto: 'Use of works',
      oma: 'Self-producing',
      cookie: 'Our website uses cookies to allow us to provide you with the best possible user experience. By continuing to use this website you accept the use of cookies.',
      lisatietoja: 'More information on the cookies',
      hyvaksyn: 'I accept'
    },
    general: {
      ladataan: 'Loading...',
      jatka: 'Continue later?',
      siirry: 'Go',
      aloita: 'Start',
      seuraava: 'Next',
      edellinen: 'Previous',
      kylla: 'Yes',
      ei: 'No',
      jatkat: 'Continue',
      oikein: 'Correct',
      vaarin: 'Incorrect',
      hienoa: 'Well done!'
    },
    footer: {
      tekijat: 'Producers',
      kayttoehdot: 'Privacy policy',
      evasteet: 'Cookies',
      yhteystiedot: 'Contact information',
      unohditko: 'Did you lose your code?',
      jaa: 'Share',
      copyright: '© Kopiosto ry.',
      some: 'Social media'
    },
    login: {
      ohje: 'By logging in, you can save the tests you have passed and continue later, even on a different device. Your email address will not be saved, and we will not use it for any other purpose than to send the login code.',
      email: 'Your e-mail address',
      koodi: 'Code',
      kirjaudu: 'Log in',
      kirjaudutaan: 'Loggin in...',
      kirjauduulos: 'Log out',
      kirjautuneena: 'Currently logged in',
      jatka: 'Continue',
      jatkakirjautumatta: 'Continue without logging in',
      eikoodia: 'If you do not have a code or you have forgotten it, leave the field empty, and we will send a code to your email.',
      laheta: 'Send a code',
      lahetetaan: 'Sending...',
      lahetetty: 'Cede sent',
      jatkamyohemmin: 'Continue later where you left off',
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale.js